<template>
  <div v-if="text.length > 0" class="render">
    <div class="notice" :class="{ 'notice--warning': warning }">
      <img v-if="warning" src="~@/assets/img/svg/icon-warning.svg" width="18" />
      <img v-else src="~@/assets/img/svg/icon-info.svg" width="18" />
      <div class="notice__info" v-html="text"></div>
      <div class="blur"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ""
    },

    warning: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.main {
  height: 100vh;
  position: relative;
  padding: 0 60px;
  display: flex;
  flex-direction: column;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: -1;
  }

  &__logo {
    width: 33.636364vw;
    height: auto;
    position: absolute;
    top: 10.4545455vw;
    left: 50%;
    transform: translateX(-50%);
  }

  &__content {
    display: flex;
    flex-direction: column;
    margin-top: auto;

    .btn {
      margin: 0;
      align-self: center;
      flex-shrink: 0;
      width: 305px;
    }
  }
}

.play-button {
  margin: 40px auto 10px auto;
}

.render {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  z-index: 10;

  &__options {
    display: flex;
  }

  &__option {
    display: flex;
    align-items: center;
    color: $white;
    padding: 15px 20px;

    & > div,
    & > span {
      pointer-events: none;
    }

    &:hover {
      .radio {
        border-color: #64e58d;
        svg {
          opacity: 1;
        }
      }
    }
  }

  .radio {
    width: 26px;
    height: 26px;
    border-style: solid;
    border-width: 2px;
    border-color: rgb(94, 94, 94);
    border-radius: 50%;
    background-color: rgb(0, 0, 0);
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      opacity: 0;
    }

    &.active {
      border-color: #64e58d;
      background-color: #64e58d;

      svg {
        opacity: 1;
        polyline {
          stroke: $dark-grey;
        }
      }
    }
  }
}

.notice {
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 20px;
  width: 100%;
  margin-top: 10px;

  &__info {
    display: flex;
    padding-left: 10px;
    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
    }
    a {
      color: $white;
      text-decoration: underline;
    }
  }
}

.rendering {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 60px;

  label {
    margin-right: 20px;
  }
}
</style>

<style lang="scss">
.notice {
  display: flex;
  // background-color: rgba(0, 0, 0, 0.5);
  position: relative;
  padding: 20px;
  width: 100%;
  margin-top: 10px;

  &::before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $black;
    opacity: 0.3;
    z-index: -1;
  }

  .blur {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(12px);
    filter: blur(1px);
    z-index: -1;
  }

  &__info {
    display: flex;
    padding-left: 10px;
    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
    }
    a {
      color: $white;
      text-decoration: underline;

      &:hover {
        color: $yellow;
      }
    }
  }
}

.notice--warning {
  border: 1px solid $orange;
}
</style>
